import { Grid, RadioGroupInput } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="Voordeel alle aard"
      description='Geniet u "voordeel alle aard"?'
      maxWidth={1000}
    >
      <Grid container spacing={2}>
        <RadioGroupInput
          name="voordeel_alle_aard_titularis"
          label="Titularis"
          items={[
            { text: 'Ja', value: 'ja' },
            { text: 'Nee', value: 'nee' },
          ]}
          xs={12}
          sm={6}
          required
        />
        <RadioGroupInput
          name="voordeel_alle_aard_partner"
          label="Partner"
          items={[
            { text: 'Ja', value: 'ja' },
            { text: 'Nee', value: 'nee' },
          ]}
          xs={12}
          sm={6}
          required
        />
      </Grid>
    </StepWrapper>
  );
}
